/* Mocca 2026 · compra rápida, kit selector e vídeos sob demanda */
(function () {
  var M = (window.mocca = window.mocca || {});

  M.money = function (cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  // Adiciona itens e vai para o checkout (fluxo curto para tráfego pago)
  M.buy = function (items, btn) {
    if (!items || !items.length) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Aguarde...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        window.location.href = '/cart';
      });
  };

  // Botões [data-mocca-buy="variantId"]
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mocca-buy]');
    if (!b) return;
    e.preventDefault();
    M.buy([{ id: parseInt(b.getAttribute('data-mocca-buy'), 10), quantity: 1 }], b);
  });

  // Kit selector: [data-mocca-kit] contém radios name=kit com data-variant e data-price,
  // add-ons opcionais [data-mocca-addon] (checkbox com data-variant) e o botão [data-mocca-kit-cta]
  function initKit(root) {
    var cta = root.querySelector('[data-mocca-kit-cta]');
    var radios = root.querySelectorAll('input[name="mocca-kit"]');
    var addons = root.querySelectorAll('[data-mocca-addon]');
    var base = cta ? cta.getAttribute('data-label') || 'Comprar agora' : '';
    function total() {
      var t = 0;
      radios.forEach(function (r) { if (r.checked) t += parseInt(r.getAttribute('data-price') || '0', 10); });
      addons.forEach(function (a) { if (a.checked) t += parseInt(a.getAttribute('data-price') || '0', 10); });
      return t;
    }
    function refresh() {
      root.querySelectorAll('label.on').forEach(function (l) { l.classList.remove('on'); });
      radios.forEach(function (r) { if (r.checked) r.closest('label').classList.add('on'); });
      if (cta) cta.textContent = base + ' · ' + M.money(total());
      var inst = root.querySelector('[data-mocca-installments]');
      if (inst) inst.textContent = 'Pix ou até 12x de ' + M.money(Math.round(total() / 12));
    }
    root.addEventListener('change', refresh);
    if (cta) cta.addEventListener('click', function (e) {
      e.preventDefault();
      var items = [];
      radios.forEach(function (r) { if (r.checked) items.push({ id: parseInt(r.getAttribute('data-variant'), 10), quantity: 1 }); });
      addons.forEach(function (a) { if (a.checked) items.push({ id: parseInt(a.getAttribute('data-variant'), 10), quantity: 1 }); });
      M.buy(items, cta);
    });
    refresh();
  }
  document.querySelectorAll('[data-mocca-kit]').forEach(initKit);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mocca-kit]').forEach(initKit);
  });

  // Vídeos sob demanda (data-src) para não estourar conexões do CDN
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
          v.muted = true; var p = v.play(); if (p) p.catch(function () {});
        } else if (v.src) { v.pause(); }
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('video[data-src]').forEach(function (v) { io.observe(v); });
  } else {
    document.querySelectorAll('video[data-src]').forEach(function (v) { v.src = v.dataset.src; });
  }
})();
